export enum ShwEnv {
  PRODUCTION = 'prod1',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  TESTING = 'testing',
}
